module.exports = __webpack_public_path__ + "media/images/athletes/505-4ba9970bffc654ac714c31885e589b1e.png";